export type FormbrewErrorOptions = {
  cause?: unknown;
  code: string;
  details?: unknown;
  status?: number | null;
};

/** A normalized Formbrew API, response, network, or configuration error. */
export class FormbrewError extends Error {
  readonly code: string;
  readonly details?: unknown;
  readonly status: number | null;

  constructor(message: string, options: FormbrewErrorOptions) {
    let errorOptions: ErrorOptions | undefined;

    if (options.cause !== undefined) {
      errorOptions = { cause: options.cause };
    }

    super(message, errorOptions);
    this.name = "FormbrewError";
    this.code = options.code;
    this.details = options.details;
    this.status = options.status ?? null;
  }
}

export const isFormbrewError = (error: unknown): error is FormbrewError =>
  error instanceof FormbrewError;

export const createConfigurationError = (message: string): FormbrewError => {
  return new FormbrewError(message, { code: "ConfigurationError" });
};

export const createInvalidResponseError = (status: number): FormbrewError => {
  return new FormbrewError("Formbrew returned an invalid response.", {
    code: "InvalidResponse",
    status,
  });
};
